import { useCallback, useEffect, useState } from "react";

import nettleProduct1 from "../../assets/images/nettleProduct_1.webp";
// import nettleProduct2 from "../../assets/images/nettleProduct_2.webp";
import nettleProduct3 from "../../assets/images/nettleProduct_3.webp";
// import nettleProduct4 from "../../assets/images/nettleProduct_4.webp";
import nettleProduct5 from "../../assets/images/nettleProduct_5.webp";
import nettleProduct6 from "../../assets/images/nettleProduct_6.webp";
import stage1AppOnly from "../../assets/images/stage1AppOnly.webp";
import stage1Nettle from "../../assets/images/stage1Nettle.webp";
import { cn } from "../../utils/styling";

// import stage2AppAnnual from "../../assets/images/stage2AppAnnual.webp";
// import stage2NettleMonthly from "../../assets/images/stage2NettleMonthly.webp";
// import stage3Authentication from "../../assets/images/stage3Authentication.webp";

const CAROUSEL_IMAGES = [
  { src: nettleProduct1, alt: "Nettle Bundle" },
  { src: stage1Nettle, alt: "Nettle Bundle" },
  { src: nettleProduct3, alt: "Nettle Bundle" },
  { src: stage1AppOnly, alt: "App Only" },
  // { src: nettleProduct2, alt: "Nettle Bundle" },
  // { src: nettleProduct4, alt: "Nettle Bundle" },
  { src: nettleProduct6, alt: "Nettle Bundle" },
  { src: nettleProduct5, alt: "Nettle Bundle" },
];

const CAROUSEL_INTERVAL = 3000; // 5 seconds

export function SideImage(): JSX.Element {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const [isPaused, setIsPaused] = useState(false);

  const resetTimer = useCallback(() => {
    setCurrentImageIndex(
      (prevIndex) => (prevIndex + 1) % CAROUSEL_IMAGES.length,
    );
  }, []);

  const handleThumbnailClick = useCallback((index: number) => {
    setCurrentImageIndex(index);
    setIsPaused(false);
  }, []);

  const handleThumbnailHover = useCallback((index: number) => {
    setHoveredIndex(index);
    setIsPaused(true);
  }, []);

  const handleThumbnailLeave = useCallback(() => {
    setHoveredIndex(null);
    setIsPaused(false);
  }, []);

  // Auto-progression timer
  useEffect(() => {
    if (isPaused) return;

    const interval = setInterval(resetTimer, CAROUSEL_INTERVAL);
    return () => clearInterval(interval);
  }, [isPaused, resetTimer]);

  const displayedImageIndex =
    hoveredIndex !== null ? hoveredIndex : currentImageIndex;
  const displayedImage =
    CAROUSEL_IMAGES[displayedImageIndex] || CAROUSEL_IMAGES[0]!;

  return (
    <div className="w-full h-full bg-canvas-base box-border flex-col flex items-center justify-center px-4 py-4">
      <div className="rounded-2xl overflow-hidden w-full h-full flex flex-col items-center justify-center relative">
        <img
          src={displayedImage.src}
          alt={displayedImage.alt}
          className="w-full h-full object-cover"
        />

        {/* Thumbnail navigation overlay */}
        <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2">
          {CAROUSEL_IMAGES.map((image, index) => (
            <button
              key={index}
              onClick={() => handleThumbnailClick(index)}
              onMouseEnter={() => handleThumbnailHover(index)}
              onMouseLeave={handleThumbnailLeave}
              className={cn(
                "w-24 h-24 rounded-lg overflow-hidden border-2 transition-all duration-200 hover:scale-105",
                index === displayedImageIndex
                  ? "border-white border-4 shadow-lg"
                  : "border-white/50 hover:border-white/80",
              )}
            >
              <img
                src={image.src}
                alt={image.alt}
                className="w-full h-full object-cover"
              />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
